import PostFormDesktop from './post-form-desktop';
import PostFormMobile from './post-form-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(PostFormMobile, PostFormDesktop);
